import {hitGoogleTagManager} from "../../../tracking/google_tag_manager/hit_google_tag_manager";

export const hitGtmSurveyClick = (eventCategory: string, value: string, section: string) => {
    const gtmData = {
        event: "survey_basic",
        event_action: "click",
        event_category: eventCategory,
        event_category2: value,
        event_category3: section
    };

    hitGoogleTagManager(gtmData);
};
import {hitGoogleTagManager} from "../../../tracking/google_tag_manager/hit_google_tag_manager";

export const hitGtmSurveyClick = (eventCategory: string, value: string, section: string) => {
    const gtmData = {
        event: "survey_basic",
        event_action: "click",
        event_category: eventCategory,
        event_category2: value,
        event_category3: section
    };

    hitGoogleTagManager(gtmData);
};
